export const menuTheme = {
  light: {
    sidebar: {
      backgroundColor: '#ECEFED',
    },
    menu: {
      menuContent: '#e5e8e6',
      hover: {
        backgroundColor: '#F4F8F6',
      },
      active: {
        backgroundColor: '#F4F8F6',
      },
    },
  },
  //fbfcfd
  dark: {
    sidebar: {
      backgroundColor: '#242524',
    },
    menu: {
      menuContent: '#171b18',
      hover: {
        backgroundColor: '#0e100f',
      },
      active: {
        backgroundColor: '#0e100f',
      },
    },
  },
}
